import React, { useEffect, useState } from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";

import moment from "moment";
import api from "../../../utils/api";
import Spinner from "../../../common/Spinner/Spinner";

export default function CentralizedSMSLogModal(props)
{
    const [auditLog,setAuditLog] = useState();
    const [isLoading, setLoading] = useState(false);
    const [ESPServiceNames,setESPServiceNames] = useState([]);
    
      useEffect(() => {
        if(props.isOpen)
        {
            if(props.sEmailAddress)
            {
                let tempserviceReqNames=[];
                if(props.serviceNameListESP&&props.serviceNameListESP.length>0)
                {
                     props.serviceNameListESP.map((e) => {
                      tempserviceReqNames.push(e.label);
                    });
                    setESPServiceNames(tempserviceReqNames);
                }
                else
                {
                  setESPServiceNames([]);
                }

                setLoading(true);
                api.getAllFollowupSMSByUserid({email: props.sEmailAddress})
                .then((d) => {
                    setAuditLog(d.data);
                    let data=d.data;
                    setLoading(false);
                });
            }            
        }
        
      }, [props.isOpen]);

     const renderAuditTrail = () => {
        return Object.keys(auditLog).map((key, i) => (
          (ESPServiceNames.length>0 && ESPServiceNames.includes(auditLog[key].sServiceName))||ESPServiceNames.length==0?
          (
            <div
                style={{paddingBottom:"5px",marginBottom:"10px",borderBottom:"1px solid lightgray"}}>
               <h5>
                   {`${auditLog[key].sServiceName} (${key}) `}
               </h5>
               {
                   auditLog[key].sms.length>0?(
                       Object.keys(auditLog[key].sms).map((key1, i) => (
                           <div className="mt-2" key={i}>
                               <div className="flex justify-content-between">
                                   <small>{auditLog[key].sms[key1].external_sp}</small>
                                   <small>{moment(auditLog[key].sms[key1].date_created).format('lll')}</small>
                               </div>
                               <div className="audits-body mt-2">
                                   <div><small>SMS</small></div>
                                   <div style={{whiteSpace: "pre-line"}}>
                                   {auditLog[key].sms[key1].sms_content}
                                   </div> 
                               </div>
                           </div>
                       ))
                   ):
                   (<div className=" audits-body">No SMS sent</div>)
               }
           </div>   
          ):
          (
            ""
          )    
       ))
      }

      return (
        <Modal
          isOpen={props.isOpen}
          onRequestClose={props.toggleModal}
          ariaHideApp={false}
        >
          <ModalContent>
            <div className="p-2 modals-headers-bar">
              <span>SMS Trail</span>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={props.toggleModal}
              >
                <X style={{ pointerEvents: "none" }} color="white" />
              </button>
            </div>
            <div
              className={`modal-body ${isLoading && "set-opacity"}`}
              style={{ overflowY: "scroll", height: "500px" }}
            >
              {/*{props.selectedSPLedService&&props.selectedSPLedService.custrefSRState!="Cancelled"&&props.selectedSPLedService.custrefSRState!="Delivered"&&
               <div>
                  <button 
                    className="btn r-button primary"
                    style={{float:"right"}}
                    onClick={(e) =>props.onAddNoteClicked(e,props.selectedSPLedService)}>
                      Add Note
                  </button>
                  <div style={{clear:"both"}}></div>
              </div> }*/}
              <div>                
                {auditLog?renderAuditTrail():<div className=" audits-body">No SMS Sent</div>}
              </div>
              {isLoading && <Spinner className="top" />}
            </div>
            
          </ModalContent>
        </Modal>
      );
}